import ProjectMetricsDashboard from '../project-metrics-dashboard/ProjectMetricsDashboard'

// This wrapper component is here for when we inevitably need to wrap the metrics dashboard for some reason
export default function ProjectDashboard() {
  return <ProjectMetricsDashboard />
}
